export const deleteItem = (itemsArray: any[], itemId: number) => {
  return itemsArray.filter((item) => item.READONLY_ID !== itemId);
};
